<div class="p-grid" style="margin: 15px;">
  <p-panel header="LISTE DES MODERATIONS RECUES" class="p-col-12" styleClass="cq" >
    <p-table #dtRecu [columns]="RecueCols" [value]="Recu" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="caption">
        <div style="text-align: right">
          <div class="ui-inputgroup recherche" >
            <span class="ui-inputgroup-addon">Rechercher :</span>
            <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dtRecu.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of RecueCols" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-moderation let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            {{moderation[col.field]}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>

  <p-panel header="LISTE DES MODERATIONS TRAITEES" class="p-col-12" styleClass="cq" >
  <p-table #dtTraite [columns]="TraiteCols" [value]="Traiter" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template pTemplate="caption">
      <div style="text-align: right">
        <div class="ui-inputgroup recherche" >
          <span class="ui-inputgroup-addon">Rechercher :</span>
          <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dtTraite.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of TraiteCols" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-moderation let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          {{moderation[col.field]}}
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
  <p-panel header="LISTE DES ECHANTILLONS TRAITEES" class="p-col-12" styleClass="cq" >
    <p-table #dtEchant [columns]="CQCols" [value]="CQ" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="caption">
        <div style="text-align: right">
          <div class="ui-inputgroup recherche" >
            <span class="ui-inputgroup-addon">Rechercher :</span>
            <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dtEchant.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of CQCols" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-moderation let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            {{moderation[col.field]}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
  <p-panel header="LISTE DES MODERATIONS LIVREES" class="p-col-12" styleClass="cq" >
    <p-table #dtLivre [columns]="LivrerCols" [value]="Livrer" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="caption">
        <div style="text-align: right">
          <div class="ui-inputgroup recherche" >
            <span class="ui-inputgroup-addon">Rechercher :</span>
            <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dtLivre.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of LivrerCols" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-moderation let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            {{moderation[col.field]}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
